import React from 'react';

export const SalaVipIcon = ({ size = 16, color = '#5A539C', className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(size * 13.3) / 11.9667}
    height={size}
    viewBox="0 0 13.3 11.9667"
    fill="none"
    className={className}
  >
    <path
      d="M11.3167 4.31667V1.98333C11.3167 1.62971 11.1762 1.29057 10.9261 1.04052C10.6761 0.790476 10.337 0.65 9.98333 0.65H3.31667C2.96304 0.65 2.62391 0.790476 2.37386 1.04052C2.12381 1.29057 1.98333 1.62971 1.98333 1.98333V4.31667"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.65 8.65C0.65 9.00362 0.790476 9.34276 1.04052 9.59281C1.29057 9.84286 1.62971 9.98333 1.98333 9.98333H11.3167C11.6703 9.98333 12.0094 9.84286 12.2595 9.59281C12.5095 9.34276 12.65 9.00362 12.65 8.65V5.98333C12.65 5.62971 12.5095 5.29057 12.2595 5.04052C12.0094 4.79048 11.6703 4.65 11.3167 4.65C10.963 4.65 10.6239 4.79048 10.3739 5.04052C10.1238 5.29057 9.98333 5.62971 9.98333 5.98333V6.98333H3.31667V5.98333C3.31667 5.62971 3.17619 5.29057 2.92614 5.04052C2.67609 4.79048 2.33696 4.65 1.98333 4.65C1.62971 4.65 1.29057 4.79048 1.04052 5.04052C0.790476 5.29057 0.65 5.62971 0.65 5.98333V8.65Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.31667 9.98333V11.3167" stroke={color} strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M10.9833 9.98333V11.3167"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/SalaVip.icon.jsx